import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import ParentContentCard from '../common/ParentContentCard';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import { convertFields, getFieldDataTypeValue } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import CustomRadio from '../../common/ui/CustomRadio';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import {
  createSelectOptionsForField,
  externalDBCollectionOptions,
  externalDBCollections,
} from './utils';
import TooltipInfo from '../../common/docs/TooltipInfo';

export class MySqlCollectionsUpdate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    fieldDatatypes: [],
    mysqlData: {},
    selectedCollectionIndex: 0,
    selectedPrimaryKey: 'id',
    collections: [],
    fieldData: [],
    selectedCollection: {},
    formattedFieldData: {},
    isExistingCollection: false,
    mappedCollection: {},
    mappedCollectionFieldOptions: [],
    mappedCollectionFields: [],
    hasExtraKey: false,
  };
  async componentDidMount() {
    const { match, actions, location } = this.props;
    const { params } = match || {};
    const { dbUuid, projectId, tableName, version } = params;

    let stateData = {};
    let isExistingCollection = false;
    let mappedCollectionId = '';
    let mappedCollectionName = '';
    let mappedCollectionFields = {};
    let mappedCollectionOption = {};

    if (location.state && location.state.collectionIndex) {
      const { collectionIndex } = this.props.location.state;
      stateData['selectedCollectionIndex'] = collectionIndex;
    }

    await actions.loadCollections({ projectId, version });
    const { collections } = this.props.dataConnector;
    const filteredCollections = externalDBCollections(collections);
    stateData['collections'] = filteredCollections;

    await actions.getMySqlExternalDb({ version, projectId, dbUuid });
    const { mysqlStoredData } = this.props.dataConnector;
    if (mysqlStoredData) {
      stateData['mysqlData'] = mysqlStoredData;

      const { completeData } = mysqlStoredData;
      let fieldData;
      let selectedCollection;
      let formattedFieldData = {};

      if (completeData) {
        selectedCollection = completeData
          ? completeData.tables[stateData['selectedCollectionIndex'] || 0]
          : null;
        fieldData = selectedCollection ? selectedCollection.fields : null;

        if (fieldData && fieldData.length) {
          formattedFieldData = fieldData.reduce((acc, field) => {
            acc[field.COLUMN_NAME] = field.DATA_TYPE;
            return acc;
          }, {});
        }

        const primaryField = fieldData.find((field) => field.COLUMN_KEY === 'PRI');
        if (!selectedCollection.selectedPrimaryKey && primaryField) {
          stateData['selectedPrimaryKey'] = primaryField.COLUMN_NAME;
        } else if (selectedCollection.selectedPrimaryKey) {
          stateData['selectedPrimaryKey'] = selectedCollection.selectedPrimaryKey;
        }

        const hasExtraKey = fieldData.some((field) => field.hasOwnProperty('EXTRA'));
        console.log('🚀 ~ MySqlCollectionsUpdate ~ componentDidMount ~ hasExtraKey:', hasExtraKey);
        stateData['hasExtraKey'] = hasExtraKey;
      }

      stateData['fieldData'] = fieldData;
      stateData['selectedCollection'] = selectedCollection;
      stateData['formattedFieldData'] = formattedFieldData;

      if (
        selectedCollection &&
        selectedCollection.isExistingCollection &&
        selectedCollection.mappedCollectionId
      ) {
        isExistingCollection = selectedCollection.isExistingCollection;
        mappedCollectionId = selectedCollection.mappedCollectionId;
        mappedCollectionName = selectedCollection.mappedCollectionName;
        mappedCollectionFields = selectedCollection.mappedCollectionFields;
        const mappedCollection = collections.find((col) => col.uuid === mappedCollectionId);
        const { fields } = mappedCollection;
        const collectionFieldOptions = createSelectOptionsForField(fields);

        mappedCollectionOption = {
          value: mappedCollectionName,
          label: mappedCollection.collectionTitle,
        };

        stateData['isExistingCollection'] = isExistingCollection;
        stateData['mappedCollection'] = mappedCollection;
        stateData['mappedCollectionOption'] = mappedCollectionOption;
        stateData['mappedCollectionFields'] = mappedCollectionFields;
        stateData['mappedCollectionFieldOptions'] = collectionFieldOptions;
      }
    }

    this.setState({ ...stateData });
  }
  handleCancel = () => {
    const { match, history } = this.props;
    const { dbUuid, projectId, version } = match.params;
    history.push(`/data-connector/${version}/v/${projectId}/mysql-datasource/${dbUuid}/edit`);
  };
  handleSave = async (values, selectedPrimaryKey) => {
    const {
      fieldDatatypes,
      mysqlData,
      selectedCollectionIndex,
      isExistingCollection,
      mappedCollection,
      mappedCollectionFields,
    } = this.state;
    const { actions, match } = this.props;
    const { projectId, dbUuid, version, tableName } = match.params;
    const { completeData, setting, name } = mysqlData;
    const newArray = completeData.tables;
    const selectedData = newArray.find((table) => table.name === tableName);
    const fieldData = selectedData.fields;

    let formattedFieldData = {};

    if (fieldData && fieldData.length) {
      formattedFieldData = fieldData.reduce((acc, field) => {
        acc[field.COLUMN_NAME] = field.DATA_TYPE;
        return acc;
      }, {});
    }

    let result = {};
    Object.keys(formattedFieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : formattedFieldData[fieldName];
    });

    if (Object.keys(result) && Object.keys(result).length) {
      result = convertFields(result);
    }

    const data = {
      version,
      collectionNames: tableName,
      collectionTitle: isExistingCollection
        ? mappedCollection.collectionTitle
        : values.collectionTitle,
      orgCollectionName: tableName,
      fields: result,
      projectId,
      setting,
      externalDatabaseId: dbUuid,
      name,
      selectedPrimaryKey,
      result,
      tableIndex: selectedCollectionIndex,
      mysqlFields: fieldData,
      isExistingCollection,
      mappedCollectionId: isExistingCollection ? mappedCollection.uuid : null,
      mappedCollectionName: isExistingCollection ? mappedCollection.collectionName : null,
      mappedCollectionFields: isExistingCollection ? mappedCollectionFields : null,
    };

    if (!isExistingCollection) {
      await actions.updateCollectionWithMySql(data);
    }

    await actions.updateMySqlExternalDb(data);
    this.handleCancel();
  };

  handleFieldTypeChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };

  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.mappedCollectionFields };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ mappedCollectionFields: updatedResult });
  };

  getMappedField = (fieldName) => {
    const { mappedCollectionFields, mappedCollectionFieldOptions } = this.state;
    if (mappedCollectionFields && mappedCollectionFields[fieldName]) {
      return mappedCollectionFields[fieldName];
    } else if (mappedCollectionFieldOptions && mappedCollectionFieldOptions[fieldName]) {
      return mappedCollectionFieldOptions[fieldName];
    }
    return '';
  };

  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };
  primaryKey = (field) => {
    return this.state.selectedPrimaryKey === field.COLUMN_NAME;
  };

  autoIncrement = (field, fields) => {
    const autoIncrementField = fields.find((field) => field.EXTRA === 'auto_increment');
    return autoIncrementField && field.COLUMN_NAME === autoIncrementField.COLUMN_NAME;
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }

    const { dataConnector } = this.props;
    const {
      updateCollectionWithMySqlPending,
      updateMySqlExternalDbPending,
      getMySqlExternalDbPending,
    } = dataConnector;
    if (getMySqlExternalDbPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={getMySqlExternalDbPending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }
    const {
      collections,
      isExistingCollection,
      mappedCollection,
      mappedCollectionFieldOptions,
      mappedCollectionOption,
      selectedCollection,
      fieldData,
      formattedFieldData,
      hasExtraKey,
    } = this.state;

    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard title={'Update Collection via MySQL'} icon={'collection'}>
          {' '}
          <Formik
            initialValues={{
              collectionTitle: selectedCollection.collectionTitle || selectedCollection.name,
            }}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue, setFieldTouched }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'MySQL Collection Name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection.name}
                      />
                    </FormFieldWithLabel>
                  </div>

                  {isExistingCollection ? (
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Existing Collection"
                        icon="select"
                        infoIcon={true}
                        infoDescription={'Collection selected for mapping with MySQL table'}
                      >
                        <CustomSelect
                          name={'collectionName'}
                          placeholder={'Select Collection for mapping'}
                          isMulti={false}
                          isDisabled={true}
                          options={externalDBCollectionOptions(collections)}
                          value={mappedCollectionOption}
                        />
                      </FormFieldWithLabel>
                    </div>
                  ) : (
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Collection Title"
                        icon="text"
                        infoIcon={true}
                        infoDescription={
                          'Enter name for the collection name if  you want to change'
                        }
                        value={selectedCollection.name}
                      >
                        <Field
                          type="text"
                          name="collectionTitle"
                          className="form-control form-control-sm"
                          placeholder="Collection Title"
                          value={values.collectionTitle}
                          onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                        />
                        <ErrorMessage
                          name="collectionTitle"
                          component="p"
                          className="text-danger"
                        />
                      </FormFieldWithLabel>
                    </div>
                  )}
                  {isExistingCollection && (
                    <div className="form-group">
                      <div className="col-12">
                        <div className="input-group" title="Map with existing collection">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="wb webconnect-toggles"></i>
                            </span>
                          </div>
                          <div className="form-check">
                            <CustomRadio label="Map with existing collection" isRadio={false}>
                              <input
                                name="isExistingCollection"
                                type="checkbox"
                                className="form-check-input disabled"
                                checked={isExistingCollection}
                                disabled={true}
                              />
                            </CustomRadio>
                          </div>
                          <TooltipInfo
                            title={'Enabled Mapping with existing Collection'}
                            headerText={`What's Map with existing Collection?`}
                            showHeader={true}
                            showArrow={true}
                            append={true}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>
                        {isExistingCollection ? 'Collection Field Mapping' : 'Field Type Mapping'}
                      </b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>MySQL Fields</th>
                          <th>MySQL Fields Type</th>
                          <th>
                            {isExistingCollection ? 'Collection Field' : 'DrapCode Field Types'}
                          </th>
                          <th style={{ width: '12%' }}>Primary Key</th>
                          {hasExtraKey && <th style={{ width: '12%' }}>AutoIncremented</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {fieldData.map((field, index) => (
                          <tr key={index}>
                            <td>{field.COLUMN_NAME}</td>
                            <td>{field.DATA_TYPE}</td>
                            <td>
                              {isExistingCollection && mappedCollection ? (
                                <CustomSelect
                                  name={field.COLUMN_NAME}
                                  placeholder={'Select Field for mapping'}
                                  isMulti={false}
                                  onChange={setFieldValue}
                                  onChangeValue={this.handleFieldChange}
                                  options={mappedCollectionFieldOptions}
                                  value={this.getMappedField(field.COLUMN_NAME)}
                                />
                              ) : (
                                <CustomSelect
                                  name={field.COLUMN_NAME}
                                  isMulti={false}
                                  onChange={setFieldValue}
                                  onChangeValue={this.handleFieldTypeChange}
                                  options={dropdownsForSource}
                                  value={getFieldDataTypeValue(
                                    field.COLUMN_NAME,
                                    formattedFieldData,
                                    this.state.fieldDatatypes,
                                  )}
                                />
                              )}
                            </td>
                            <td style={{ width: '12%' }}>
                              <div className="form-check ml-4 pl-3">
                                <CustomRadio label="" isRadio={false}>
                                  <Field
                                    type="checkbox"
                                    name={field.COLUMN_NAME}
                                    className="form-check-input"
                                    checked={this.primaryKey(field)}
                                    disabled={
                                      selectedCollection.selectedPrimaryKey === field.COLUMN_NAME
                                        ? false
                                        : true
                                    }
                                  />
                                </CustomRadio>
                              </div>
                            </td>
                            {hasExtraKey && (
                              <td style={{ width: '12%' }}>
                                <div className="form-check ml-4 pl-3">
                                  <CustomRadio
                                    label=""
                                    isRadio={false}
                                    extraClass="disabled-checkbox no-pointer-events"
                                  >
                                    <Field
                                      type="checkbox"
                                      name={field.COLUMN_NAME}
                                      className="form-check-input"
                                      checked={this.autoIncrement(field, fieldData)}
                                      disabled={true}
                                    />
                                  </CustomRadio>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Cancel"
                      type="button"
                      onClick={this.handleCancel}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      title="Save Collection"
                      onClick={() => this.handleSave(values, selectedCollection.selectedPrimaryKey)}
                      disabled={updateCollectionWithMySqlPending || updateMySqlExternalDbPending}
                    >
                      <i className="wb webconnect-save-regular"></i> Update
                      <CustomLoader
                        loading={updateCollectionWithMySqlPending || updateMySqlExternalDbPending}
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MySqlCollectionsUpdate);
